const Orientation = {
  lockToPortrait: () => {},
  lockToLandscape: () => {},
  lockToLandscapeLeft: () => {},
  lockToLandscapeRight: () => {},
  unlockAllOrientations: () => {},
  addOrientationListener: () => {},
  removeOrientationListener: () => {},
  getInitialOrientation: () => 'PORTRAIT',
  getOrientation: (cb) => cb && cb('PORTRAIT'),
  getDeviceOrientation: (cb) => cb && cb('PORTRAIT'),
  addDeviceOrientationListener: () => {},
  removeDeviceOrientationListener: () => {},
};

module.exports = Orientation;
module.exports.default = Orientation;
